import PropTypes from 'prop-types';
import React from 'react';

import Text, { ENUM_COLORS, ENUM_FONTS, OVERFLOW_STYLE_TEXT } from '@commons/Text';

import { ProductNames, ProductPicture } from './styledComponents';

const DEFAULT_PRODUCT_PICTURE = '/images/inpulse/product-photo-placeholder.svg';

/** Identity of a product in an order table: its picture, its name and its SKU below. */
const OrderProductNameCell = (props) => {
  const { name, sku, img } = props;

  return (
    <>
      <ProductPicture src={img || DEFAULT_PRODUCT_PICTURE} />
      <ProductNames>
        <Text
          color={ENUM_COLORS.DARKEST}
          font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}
          style={OVERFLOW_STYLE_TEXT}
        >
          {name}
        </Text>
        <Text
          color={ENUM_COLORS.DARKER}
          font={ENUM_FONTS.TEXT_SMALL_HEIGHT_16}
          style={OVERFLOW_STYLE_TEXT}
        >
          {sku || '-'}
        </Text>
      </ProductNames>
    </>
  );
};

OrderProductNameCell.propTypes = {
  name: PropTypes.string,
  sku: PropTypes.string,
  img: PropTypes.string,
};

OrderProductNameCell.defaultProps = {
  name: '',
  sku: '',
  img: '',
};

export default OrderProductNameCell;
